import { createUseStyles } from 'react-jss'

interface StatusMessageProps {
  message: string
  subMessage?: string
  latestSubmitDateIntro?: string
  latestSubmitDate?: string
  payrollCreationMessage?: string
  payrollCreationDate?: string
  earliestPayrollCreationMessage?: string
  earliestPayrollCreatedDate?: string
}

const StatusMessage = ({ 
  message, 
  subMessage, 
  latestSubmitDateIntro, 
  latestSubmitDate,
  payrollCreationMessage,
  payrollCreationDate,
  earliestPayrollCreationMessage,
  earliestPayrollCreatedDate
}: StatusMessageProps) => {
  const styles = useStyles()

  return (
    <div className={styles.statusMessageContainer}>
      <h5>{message}</h5>
      {subMessage && <h6>{subMessage}</h6>}
      {earliestPayrollCreationMessage && <h6>{earliestPayrollCreationMessage} <strong> {earliestPayrollCreatedDate}</strong>.</h6>}
      {payrollCreationMessage && <h6>{payrollCreationMessage} <strong>{payrollCreationDate}</strong>.</h6>}
      {latestSubmitDateIntro && <h6>{latestSubmitDateIntro} <strong> {latestSubmitDate}</strong>.</h6>}
    </div>
  )
}

const useStyles = createUseStyles({
  statusMessageContainer: {
    display: 'flex',
    flex: 1,
    flexGrow: 1,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'center',
    marginTop: 20,  
    marginBottom: 10,
    rowGap: 15 
  }
})

export default StatusMessage 